import React from 'react';
import '../styles/Footer.css'; // Import CSS for styling

const Footer = () => {
  return (
    <footer className="footer">
      <p className="copyright">
        &copy; {new Date().getFullYear()} AIOTICS PVT LTD. All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;